export function regHtml(str){
    if(str){
        const reg = /<[^<>]+>/g
        str = str.replace(reg,'');
        str = str.replace(/&nbsp;/g,'')
        return str; 
    }
    
}